module.exports = __webpack_public_path__ + "static/media/parentreg-bg.867d0303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/parentreg-bg.jpg
// module id = 1057
// module chunks = 0